import React from "react";
import PropTypes from "prop-types";

import "./Highlight.css";

/**
 * Add a highlighting effect to a block.
 * Wrap a block in this element, and pass `isHighlighted={true}` and the
 *   block will be highlighted with an animation.
 */
export default class Highlight extends React.Component {
  
  static propTypes = {
    /**
     * Control the theme of the highlighting applied.
     * Valid options are defined in the CSS.
     */
    cssModifier: PropTypes.string,
    /**
     * Pass `true` to highlight the element.
     * You may immediately revert to `false`, but the animation
     *   will continue until it ends.
     */
    isHighlighted: PropTypes.bool.isRequired
  }
  
  static getDerivedStateFromProps(nextProps) {
    if (nextProps.isHighlighted) {
      return { isHighlighting: true }
    }
    return null;
  }
  
  state = {
    isHighlighting: false
  }
  
  onAnimationEnd = () => {
    this.setState({ isHighlighting: false });
  }
  
  render() {
    
    const { cssModifier } = this.props;
    const { isHighlighting } = this.state;
    
    const classNames = [ "highlight" ];
    if (isHighlighting) {
      classNames.push("highlight--active");
    } else {
      classNames.push("highlight--inactive");
    }
    if (cssModifier !== undefined) {
      classNames.push(`highlight--${cssModifier}`);
    }
    
    return (
      <div className={classNames.join(" ")} onAnimationEnd={this.onAnimationEnd}>
        { this.props.children }
      </div>
    );
    
  }
  
}



// WEBPACK FOOTER //
// ./src/components/Highlight.js